<template>
  <div class="login-page">
    <div class="login-box">
      <h2 class="title">高小畅管理后台</h2>
      <el-form :model="form" :rules="rules" ref="form" label-width="70px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" autocomplete="off" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" type="password" autocomplete="off" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" style="width: 100%;" @click="onSubmit">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import request from '@/api/request'

export default {
  name: 'Login',
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      loading: false,
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.loading = true
        request
          .post('/auth/login', {
            username: this.form.username,
            password: this.form.password
          })
          .then(res => {
            this.loading = false
            if (res && res.data && res.data.token) {
              window.localStorage.setItem('admin_token', res.data.token)
              window.localStorage.setItem('admin_username', res.data.username || this.form.username)
              window.localStorage.setItem('admin_role', res.data.role || '')
              this.$message.success('登录成功')
              this.$router.replace('/dashboard')
            } else {
              this.$message.error(res.msg || res.message || '登录失败')
            }
          })
          .catch(err => {
            this.loading = false
            const msg = (err && (err.msg || err.message)) || '登录失败'
            this.$message.error(msg)
          })
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #001529;
}

.login-box {
  width: 360px;
  padding: 32px 32px 24px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.title {
  text-align: center;
  margin-bottom: 24px;
  font-size: 20px;
}
</style>

